// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"movie-clapper"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 9L21 9L21 21L3 21C3 17 3 13 3 9Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 3L21 3V9L3 9C3 7 3 5 3 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21M3 3C3 9 3 15 3 21H21V3M3 3C3 5 3 7 3 9H21V3M6.41667 3.5L10.5833 8.5M13.4167 3.5L17.5833 8.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 13H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MovieClapperIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'movie-clapper',
    ref,
    icon: element,
  },
));

MovieClapperIcon.displayName = 'MovieClapperIcon';

export default MovieClapperIcon;
